import { useFormController } from '@dreryk/react-common';

import { MedicineRawMaterialTableBean } from '../../shared/formFields/magistralDrug/medicineRawMaterials/MedicineRawMaterialTable.types';

import { MagistralDrugCreateFormBean, MagistralDrugCreateFormController } from './MagistralDrugCreateForm.types';

export const createInitialMedicineRawMaterial = (): MedicineRawMaterialTableBean => ({
   name: '',
   rpw: false,
   excessive: false,
   quantity: 0.01,
   unit: 'GRAMS',
   quantityAbbreviation: null,
});

export const useMagistralDrugCreateFormController = (): MagistralDrugCreateFormController => {
   return useFormController<MagistralDrugCreateFormBean>({
      drugName: null,
      drugForm: null,
      additionalDetails: null,
      medicineRawMaterials: [createInitialMedicineRawMaterial()],
   });
};
